import { KeyPrefixActionitem, createPrefixedKey } from '@nucleus/ncu-key-prefix';
import {
  Height,
  InfoButtonsLayout,
  InfoButtonsWidth,
  InfoMaxWidth,
  SectionLayout,
  SectionTypeEnum,
} from '@nucleus/types/web';
import { Alignment } from '@nucleus/types/web/alignment';
import { Position } from '@nucleus/types/web';
import { SectionDefaultBuilder } from '../SectionDefaultBuilder';

const builder = new SectionDefaultBuilder<SectionTypeEnum.Header>().setStatic((config) => ({
  name: config.title,
  layout: SectionLayout.Full,
  backgroundMedia: { presetMediaKey: 'sectionBackground', presetMediaOrder: 'first' },
  blockBackgroundMedia: {
    useImage: true,
    image: config.lookConfig?.placeholders?.LightBokeh,
    presetMediaKey: 'blockBackground',
    presetMediaOrder: 'first',
  },
  colorPaletteVariation: 'variation-1',
  height: Height.Medium,
  blocks: [
    {
      behavior: 'fixed',
      backgroundBehavior: 'auto',
      brandIdentity: {
        useLogo: false,
        useText: true,
        text: '',
      },
      actions: [
        {
          id: createPrefixedKey(KeyPrefixActionitem),
          type: 'signIn',
          title: 'Sign In',
          displayAs: 'style1',
          openInNewTab: false,
        },
      ],
      navigation: undefined,
    },
  ],
  blockLayout: config.layout,
  blockLayoutVariant: 'variant1',
  blockEnabledInfo: {
    actions: true,
    brandIdentity: true,
    navigation: true,
  },
  blockInfoPosition: Position.Center,
  blockHeadlineAlignment: Alignment.Left,
  blockHeadlineMaxWidth: InfoMaxWidth.Medium,
  blockBodyAlignment: Alignment.Left,
  blockButtonsAlignment: Alignment.Left,
  blockButtonsLayout: InfoButtonsLayout.Vertical,
  blockButtonsWidth: InfoButtonsWidth.Auto,
  blockMediaOptions: {
    useColor: false,
    useImage: true,
    useVideo: false,
    image: {
      scale: 'cover',
      tile: 'none',
    },
    blending: {
      opacity: 1,
      blendMode: 'none',
      fade: 'none',
    },
  },
}));

export default builder.build();
